import { createContext } from 'react';

export interface IPopupContext {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DEFAULT: IPopupContext = {
    visible: false,
    setVisible(): void {
        throw new Error('Function not implemented.');
    }
};

export default createContext<IPopupContext>(DEFAULT);
